import api from '@services/api';
import { AllocationData, BranhcResponse, ColaboratorsRequest } from '../models/avaliablePercent';

/**
 * <p>
 * API endpoints that cover all resource period related CRUD calls
 */
export const AvaliablePercetApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listAllGroupedAvaliablePercent: builder.query<AllocationData[], void>({
      query: () => ({
        url: encodeURI(`/indirect/rule-available-percent/findAllGrouped`),
      }),
      providesTags: ['listAllGroupedAvaliablePercent'],
    }),
    findBybranchAvaliablePercent: builder.query<BranhcResponse[], string>({
      query: (request) => ({
        url: encodeURI(`/indirect/rule-available-percent/findByBranch?branchCode=${request}`),
      }),
      providesTags: ['findBybranchAvaliablePercent'],
    }),
    deleteAvaliablePercent: builder.mutation<void, string>({
      query: (request) => ({
        url: encodeURI(`/indirect/rule-available-percent/delete?branchCode=${request}`),
        method: 'DELETE',
      }),
      invalidatesTags: ['listAllGroupedAvaliablePercent'],
    }),
    AddCollaborator: builder.mutation<void, ColaboratorsRequest>({
      query: (input) => ({
        url: `/indirect/rule-available-percent/create`,
        method: 'POST',
        body: input,
      }),
      invalidatesTags: ['listAllGroupedAvaliablePercent'],
    }),
  }),
});

export const {
  useListAllGroupedAvaliablePercentQuery,
  useFindBybranchAvaliablePercentQuery,
  useDeleteAvaliablePercentMutation,
  useAddCollaboratorMutation,
} = AvaliablePercetApi;
